import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";

import { store } from "./helpers";
import { App } from "./core";

import 'semantic-ui-less/semantic.less';
import { HashRouter } from 'react-router-dom';

render(
  <Provider store={store}>
    <HashRouter>
      <App />
    </HashRouter>
  </Provider>,
  document.getElementById("app")
);
